import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { translate } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { logger } from '@fiverr-private/obs';
import { ContactButton, useLocalizationContext } from '@fiverr-private/seller_pages_toolbox';
import { useContactMeProfessionBIExtensionData } from '../BIContext';
import { useSelectedRole } from '../../hooks/useSelectedRole';

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the RolePageStickyFooter Component');
    logger.error(err, {
        cause: originalError,
    });
};

export const RolePageStickyFooter = ({ onContactOpen }: { onContactOpen: () => void }) => {
    const contactMeBIExtension = useContactMeProfessionBIExtensionData();
    const selectedRole = useSelectedRole();
    const { forceRoundCurrencyFormatFromUSD } = useLocalizationContext();

    const price =
        typeof selectedRole?.startingPrice === 'number'
            ? forceRoundCurrencyFormatFromUSD(selectedRole.startingPrice)
            : null;

    return (
        <ErrorBoundary onError={onRenderError}>
            <Stack
                gap="0"
                paddingY="4"
                paddingX="6"
                hidden={{ default: false, lg: true }}
                position="fixed"
                bottom="0px"
                left="0px"
                width="100%"
                boxShadow="z3"
                background="white"
                alignItems="center"
                style={{ zIndex: 5 }}
                justifyContent={{ default: 'spaceBetween', sm: 'flexEnd' }}
            >
                {price && (
                    <Stack
                        flexGrow={{ default: '1', sm: '0' }}
                        alignContent="center"
                        justifyContent={{ default: 'center', sm: 'flexStart' }}
                        paddingX={{ default: '5', sm: '0' }}
                        marginRight={{ default: '0', sm: '8' }}
                    >
                        <Container
                            display={{ default: 'flex', sm: 'inlineBlock' }}
                            direction="column"
                            gap="0"
                            fontSize="b_xs"
                            textAlign={{ default: 'center', sm: 'start' }}
                            color="grey_900"
                        >
                            {translate('seller_page_perseus.professions_page.footer.price', {
                                params: { price },
                                templates: {
                                    b: (text) => (
                                        <Typography
                                            style={{ verticalAlign: 'middle' }}
                                            color="grey_1200"
                                            fontWeight="semibold"
                                            as="b"
                                            size="h_xs"
                                        >
                                            {text}
                                        </Typography>
                                    ),
                                },
                            })}
                        </Container>
                    </Stack>
                )}
                <Container flexGrow={{ default: '1', sm: '0' }}>
                    <ContactButton
                        size="md"
                        onContactOpen={onContactOpen}
                        biEnrichment={contactMeBIExtension}
                        title={translate('seller_page_perseus.professions_page.sidebar.contact') as string}
                    />
                </Container>
            </Stack>
        </ErrorBoundary>
    );
};
